import { render } from "./InspectionCheckPage.vue?vue&type=template&id=5235c2ac"
import script from "./InspectionCheckPage.vue?vue&type=script&lang=js"
export * from "./InspectionCheckPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__